import React, { useContext, useEffect, useRef, useState } from "react";
import { data, useNavigate } from "react-router-dom";
import { getUserData } from "../../utils/localStorage";
import {
  getReadyGarmentToSendToWarehouse,
  getStoreWarehouseInfo,
  getStoreWarehouseQrCodeByStatus,
  getStoreWarehouseQrCodeByStatusSearch,
  postSendToWareHouse,
  toGenerateChallan,
} from "../../services/warehouse/StoreWarehouse";
import { InputText } from "primereact/inputtext";
import SuccessModal from "../SuccessModal";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { ProgressSpinner } from "primereact/progressspinner";

import addItemSound from '../../assets/sounds/warehousesound3.mp3';
import BeepSound from '../../assets/sounds/alert-beep.wav';
import { localeDateEndDate, localeDateStartDate } from "../../constants/DateUtil/DateUtil";
import { Calendar } from "primereact/calendar";

const SendToWarehouse = () => {
  const navigate = useNavigate();

  const { storeData, brandProfileData } = getUserData();

  const storeId = storeData.id;
  const brandId = brandProfileData.id;
  let enabledRfIdModal = brandProfileData.enabledRfIdModal;

  const audioRef = useRef(new Audio(addItemSound));
  const handleAddItem = () => {
    const audio = audioRef.current;
    audio.currentTime = 0; // Restart from beginning
    audio.play();
  };
  const audioRefBeep = useRef(new Audio(BeepSound));
  const handleAlreadyAddedItem = () => {
    const audio = audioRefBeep.current;
    audio.currentTime = 0; // Restart from beginning
    audio.play();
  };

  const [modalVisible, setModalVisible] = useState(false);
  const [qrCodes, setQrCodes] = useState(null);
  const [qrCodes2, setQrCodes2] = useState([]);
  const [selectedQrCodes, setSelectedQrCodes] = useState([]);
  const [selectedQrCodesChecked, setSelectedQrCodesChecked] = useState([]);
  const [selectedQrCodesCheckedRFID, setSelectedQrCodesCheckedRFID] = useState([]);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [warehouseList, setWarehouseList] = useState([]);
  const [warehouseValue, setWarehouseValue] = useState("");
  const [isSendButtonPressed, setIsSendButtonPressed] = useState(false);
  const [isSaveButtonPressed, setIsSaveButtonPressed] = useState(false);
  const [loading, setLoading] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");

  const [dataProvider, setDataProvider] = useState([]);
  const [searchMethod, setSearchMethod] = useState(true);
  const [searchByInvoiceMethod, setSearchByInvoiceMethod] = useState(false);
  const [qrMethod, setQrMethod] = useState(false);
  const [rfidMethod, setRfidMethod] = useState(false);
  const [changeQrMethod, setChangeQrMethod] = useState(false);
  const [changeScannerMethod, setChangeScannerMethod] = useState(false);
  const [searchTermFocus, setSearchTermFocus] = useState("");
  const inputRef = useRef(null);

  const getInvoiceNo = (qrCode) => qrCode.split("OI")[0];

  const [dataProviderSuggestion, setDataProviderSuggestion] = useState([]);
  const [inProcessCount, setInProcessCount] = useState([])

  // For StartDate and EndDate in Api
  const minimumDate = new Date();
  minimumDate.setDate(minimumDate.getDate() - 7);

  let initialStartDate = new Date();
  initialStartDate.setDate(initialStartDate.getDate() - 1); // 1 day by default and date range 7 days

  // If orderFilterData is available, use its start and end dates
  const [startDate, setStartDate] = useState(new Date(initialStartDate));
  let initialEndDate = new Date();
  const [endDate, setEndDate] = useState(new Date(initialEndDate));

  const [allQrcodeData, setAllQrcodeData] = useState([])

  // Date Change Function
  const handleStartDateChange = (selectedDate) => {
    if (selectedDate !== undefined) {

      const currentTime = new Date();
      selectedDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds(), currentTime.getMilliseconds());

      setStartDate(selectedDate);
    }
  };

  // Warehouse Selection Data

  const fetchData = () => {
    getStoreWarehouseInfo(storeId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const warehouseData = response.data.map((item) => ({
            code: item.id,
            name: item.wareHouse.name,
          }));
          setWarehouseList(warehouseData);
          if (warehouseData.length == 1) setWarehouseValue(warehouseData[0]);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };


  // Get READY_TO_SEND_WARE_HOUSE QrCode
  const fetchData2 = (data) => {
    getStoreWarehouseQrCodeByStatusSearch(storeId, data)
      .then((response) => {
        if (!response.data.error) {
          const InProcessData = response.data.filter((item) => item.status === "IN_PROCESS");
          const ReadyToSendWareHouseData = response.data.filter((item) => item.status === "READY_TO_SEND_WARE_HOUSE");
          setQrCodes2(ReadyToSendWareHouseData);
          setInProcessCount(InProcessData);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  // Api for Qrcode Search on the basis of invoice number
  let qrCodeMap = new Map();
  const fetchQrSearchApi = (data, type) => {
    // setLoading(true);
    getStoreWarehouseQrCodeByStatusSearch(storeId, data)
      .then((response) => {
        if (!response.data.error) {
          if (type === "single") {
            response.data.forEach((element) => {
              let garmentInfo = {
                garment: element.garment,
                rfid: element.rfid,
                // createdDate: element.createdDate,
              };
              qrCodeMap.set(element.qrcode, garmentInfo);
            });
            const suggestions = [];
            qrCodeMap?.forEach((garment, qrCode) => {
              if (qrCode?.toLowerCase().startsWith(searchTerm.toLowerCase())) {
                suggestions.push({ qrCode, garment });
              }
            });

            setDataProviderSuggestion(suggestions);
            setQrCodes(qrCodeMap);
          }

          if (type === "multi") {
            handleScanAll(response.data)
          }
          // setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  // Api for Qrcode search on the basis of qrcode number
  // const fetchQrSearchApiQrCode = async (data) => {
  //   try {
  //     const response = await getStoreWarehouseQrCodeByStatusSearch(storeId, data);

  //     if (response?.data?.length) {
  //       const qrItem = response.data[0];

  //       if (
  //         !selectedQrCodesChecked.includes(qrItem.qrcode)
  //       ) {
  //         const scannedData = {
  //           garment: qrItem.garment,
  //           rfid: qrItem.rfid,
  //           qrcode: qrItem.qrcode,
  //         };

  //         setSelectedQrCodes((prev) => [...prev, scannedData]);
  //         setDataProvider((prev) => [...prev, scannedData]);
  //         setSelectedQrCodesChecked((prev) => [
  //           ...prev,
  //           qrItem.qrcode,
  //         ]);

  //         handleAddItem();
  //       } else {
  //         setAlreadyPresentData(
  //           `Tag ${qrItem.qrcode} is already exists.`
  //         );
  //       }

  //       setSearchTermFocus("");
  //       refocusInput();
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  // // api for qrcode search on the basis of rfid tag number
  // const fetchQrSearchApiRFID = async (requestData, scannedRfid) => {
  //   try {
  //     const response = await getStoreWarehouseQrCodeByStatusSearch(
  //       storeId,
  //       requestData
  //     );

  //     if (!response?.data?.length) {
  //       setAlreadyPresentData(`RFID ${scannedRfid} not found.`);
  //       refocusInput();
  //       setSearchTermFocus("");
  //       return;
  //     }

  //     const qrItem = response.data[0];

  //     const scannedData = {
  //       garment: qrItem.garment,
  //       rfid: qrItem.rfid,
  //       qrcode: qrItem.qrcode,
  //     };

  //     setSelectedQrCodes((prev) => [...prev, scannedData]);
  //     setDataProvider((prev) => [...prev, scannedData]);

  //     // Store RFID for duplicate checking
  //     setSelectedQrCodesChecked((prev) => [...prev, qrItem.qrcode]);
  //     setSelectedQrCodesCheckedRFID((prev) => [...prev, scannedRfid]);

  //     handleAddItem();

  //     setSearchTermFocus("");
  //     refocusInput();
  //   } catch (error) {
  //     console.error("RFID Search Error:", error);
  //     setAlreadyPresentData("Failed to fetch RFID data.");
  //   }
  // };

  const fetchQrSearchApiQrCode = async data => {
    try {
      const response = await getStoreWarehouseQrCodeByStatusSearch(
        storeId,
        data,
      );

      if (response?.data?.length) {
        const qrItem = response.data[0];
        if (qrItem.status === "IN_PROCESS") {

          // const isAlreadyAdded = selectedQrCodes.some(
          //   item =>
          //     item.qrcode === qrItem.qrcode ||
          //     item.rfid === qrItem.rfid,
          // );

          const isAlreadyAdded = selectedQrCodes.some(
            item =>
              item.qrcode === qrItem.qrcode ||
              (
                item.rfid &&
                qrItem.rfid &&
                item.rfid === qrItem.rfid
              )
          );

          if (!isAlreadyAdded) {
            const scannedData = {
              garment: qrItem.garment,
              rfid: qrItem.rfid,
              qrcode: qrItem.qrcode,
            };

            setSelectedQrCodes(prev => [...prev, scannedData]);
            setDataProvider(prev => [...prev, scannedData]);

            setSelectedQrCodesChecked((prev) => [
              ...prev,
              qrItem.qrcode,
            ]);

            handleAddItem();
            handleReadyToSendToWarehouseBySelection([scannedData])
            setAlreadyPresentData("")
          } else {
            setAlreadyPresentData(
              `Tag ${qrItem.qrcode} is already exists.`,
            );
            handleAlreadyAddedItem();
          }

          setSearchTermFocus('');
          refocusInput();
        } else if (qrItem.status === "READY_TO_SEND_WARE_HOUSE") {
          setAlreadyPresentData(
            `Tag ${qrItem.qrcode} is already saved.`,
          );
          handleAlreadyAddedItem();
          setSearchTermFocus('');
          refocusInput();
        } else if (qrItem.status === "SENT_TO_WARE_HOUSE") {
          setAlreadyPresentData(
            `Tag ${qrItem.qrcode} is already in warehouse.`,
          );
          handleAlreadyAddedItem();
          setSearchTermFocus('');
          refocusInput();
        } else {
          setAlreadyPresentData(
            `Tag ${qrItem.qrcode} is already existed.`,
          );
          handleAlreadyAddedItem();
          setSearchTermFocus('');
          refocusInput();
        }
      }
    } catch (error) {
      console.error('QR Search Error:', error);
    }
  };

  const fetchQrSearchApiRFID = async (
    requestData,
    scannedRfid,
  ) => {
    try {
      const response = await getStoreWarehouseQrCodeByStatusSearch(
        storeId,
        requestData,
      );

      if (!response?.data?.length) {
        setAlreadyPresentData(`RFID ${scannedRfid} not found.`);
        refocusInput();
        setSearchTermFocus('');
        return;
      }

      const qrItem = response.data[0];

      if (qrItem.status === "IN_PROCESS") {

        const isAlreadyAdded = selectedQrCodes.some(
            item =>
              item.qrcode === qrItem.qrcode ||
              (
                item.rfid &&
                qrItem.rfid &&
                item.rfid === qrItem.rfid
              )
          );

        if (!isAlreadyAdded) {
          const scannedData = {
            garment: qrItem.garment,
            rfid: qrItem.rfid,
            qrcode: qrItem.qrcode,
          };

          setSelectedQrCodes(prev => [...prev, scannedData]);
          setDataProvider(prev => [...prev, scannedData]);

          setSelectedQrCodesChecked((prev) => [...prev, qrItem.qrcode]);
          setSelectedQrCodesCheckedRFID((prev) => [...prev, scannedRfid]);
          handleAddItem();
          handleReadyToSendToWarehouseBySelection([scannedData])
          setAlreadyPresentData()
        } else {
          setAlreadyPresentData(
            `Tag ${qrItem.qrcode} is already exists.`,
          );
          handleAlreadyAddedItem();
        }

        setSearchTermFocus('');
        refocusInput();
      } else if (qrItem.status === "READY_TO_SEND_WARE_HOUSE") {
        setAlreadyPresentData(
          `Tag ${qrItem.qrcode} is already saved.`,
        );
        handleAlreadyAddedItem();
        setSearchTermFocus('');
        refocusInput();
      } else if (qrItem.status === "SENT_TO_WARE_HOUSE") {
        setAlreadyPresentData(
          `Tag ${qrItem.qrcode} is already in warehouse.`,
        );
        handleAlreadyAddedItem();
        setSearchTermFocus('');
        refocusInput();
      } else {
        setAlreadyPresentData(
          `Tag ${qrItem.qrcode} is already existed.`,
        );
        handleAlreadyAddedItem();
        setSearchTermFocus('');
        refocusInput();
      }
    } catch (error) {
      console.error('RFID Search Error:', error);
      setAlreadyPresentData('Failed to fetch RFID data.');
    }
  };

  // api for all qr invoice number
  const fetchAllQrSearchApi = (data) => {
    // setLoading(true);
    getStoreWarehouseQrCodeByStatusSearch(storeId, data)
      .then((response) => {
        if (!response.data.error) {
          const res = response.data;

          setAllQrcodeData(res);
          // setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };


  // calling of READY_TO_SEND_WARE_HOUSE data
  useEffect(() => {
    fetchData();

    const data = {
      brandId: brandId,
      storeIdIn: [storeId],
      searchText: "",
      searchBy: "",
      recordType: "",
      requestType: "status",
      startDate: "",
      endDate: "",
      status: [
        "READY_TO_SEND_WARE_HOUSE", "IN_PROCESS"
      ],
    }

    fetchData2(data)

  }, []);

  // handle scan all
  const handleScanAll = (items) => {
    const allItems = items.map((item) => ({
      garment: item.garment,
      rfid: item.rfid,
      // createdDate: item.garment.createdDate,
      qrcode: item.qrcode,
    }));

    const newQrCodes = allItems.filter(
      (obj) => !selectedQrCodesChecked.includes(obj.qrcode)
    );

    setSelectedQrCodes((prev) => [...prev, ...newQrCodes]);
    setDataProvider((prev) => [...prev, ...newQrCodes]);
    setSelectedQrCodesChecked((prev) => [
      ...prev,
      ...newQrCodes.map((i) => i.qrcode),
    ]);

    handleReadyToSendToWarehouseBySelection([...newQrCodes])
    handleAddItem();
  };

  // handle clear search
  const handleClearSearch = () => {
    setSearchTermFocus("");
    setAlreadyPresentData("");
  };

  const [alreadyPresentData, setAlreadyPresentData] = useState("");

  const refocusInput = () => {
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus(); // Refocus the input
      }
    }, 10); // Add slight delay to ensure it focuses after processing
  };

  // handle scan data
  const handleScan = ({ data }) => {
    if (data) {
      setAlreadyPresentData("");
      // Ensure data exists
      if (qrCodes?.has(data)) {
        setSearchTermFocus("");
        if (!selectedQrCodesChecked.includes(data)) {
          let scannedData = {
            garment: qrCodes?.get(data).garment,
            rfid: qrCodes?.get(data).rfid,
            // createdDate: qrCodes?.get(data).createdDate,
            qrcode: data,
          };
          setSelectedQrCodes([...selectedQrCodes, scannedData]);
          setDataProvider([...selectedQrCodes, scannedData]);
          handleAddItem()
          handleReadyToSendToWarehouseBySelection([...selectedQrCodes, scannedData])
          setSelectedQrCodesChecked([...selectedQrCodesChecked, data]);
          refocusInput(); // Refocus input
          setSearchTermFocus("");
        } else {
          setAlreadyPresentData(`Tag ${data} is already exists.`);
          handleAlreadyAddedItem();
          refocusInput(); // Refocus input
          setSearchTermFocus("");
        }
      }
    } else {
      console.error("Scanned QR data is null or undefined");
      refocusInput(); // Refocus input
      setSearchTermFocus("");
    }
  };

  // handle warehouse change data 
  const handleWarehouseChange = (selectedItem) => {
    setWarehouseValue(selectedItem);
  };

  // api calling of search qrcode by invoice number
  useEffect(() => {
    if (!searchTerm?.trim()) {
      setDataProviderSuggestion([]);
      setQrCodes({})
      return;
    }

    const timer = setTimeout(() => {
      const data = {
        brandId,
        storeIdIn: [storeId],
        searchText: searchTerm,
        searchBy: "invoice",
        recordType: "",
        startDate: localeDateStartDate(new Date(startDate)),
        // stateDate: "2026-06-01T00:00:00.000Z",
        endDate: localeDateEndDate(new Date(endDate)),
        status: ["IN_PROCESS"],
        localeDTO: {}
      };

      fetchQrSearchApi(data, "single");
    }, 300);

    return () => clearTimeout(timer);
  }, [searchTerm]);

  // api calling of qrcode search
  const handleScanQrMethod = ({ data }) => {
    if (!data?.trim()) {
      setDataProviderSuggestion([]);
      setQrCodes({});
      return;
    }

    // Duplicate tag check
    if (selectedQrCodesChecked.includes(data)) {
      setAlreadyPresentData(`Tag ${data} already exists.`);
      refocusInput();
      handleAlreadyAddedItem();
      setSearchTermFocus("");
      return;
    }

    const requestData = {
      brandId,
      storeIdIn: [storeId],
      searchText: data,
      searchBy: "qrcode",
      recordType: "",
      startDate: localeDateStartDate(new Date(startDate)),
      endDate: localeDateEndDate(new Date(endDate)),
      // status: ["IN_PROCESS"],
      status: ["SENT_TO_WARE_HOUSE", "IN_PROCESS", "READY_TO_SEND_WARE_HOUSE"],
      localeDTO: {}
    };

    fetchQrSearchApiQrCode(requestData);
  };

  // api calling of rfid 
  const handleScanRFID = ({ data }) => {

    if (!data?.trim()) {
      setDataProviderSuggestion([]);
      setQrCodes({});
      return;
    }

    // Duplicate RFID check
    if (selectedQrCodesCheckedRFID.includes(data)) {
      setAlreadyPresentData(`Tag ${data} already exists.`);
      refocusInput();
      handleAlreadyAddedItem();
      setSearchTermFocus("");
      return;
    }

    setAlreadyPresentData("");

    const requestData = {
      brandId,
      storeIdIn: [storeId],
      searchText: data,
      searchBy: "rfid",
      recordType: "",
      startDate: localeDateStartDate(new Date(startDate)),
      endDate: localeDateEndDate(new Date(endDate)),
      // status: ["IN_PROCESS"],
      status: ["SENT_TO_WARE_HOUSE", "IN_PROCESS", "READY_TO_SEND_WARE_HOUSE"],
      localeDTO: {},
    };

    fetchQrSearchApiRFID(requestData, data);
  };

  // api calling for get all invoice number
  const handleAllTodayQrCode = () => {

    const requestData = {
      brandId,
      storeIdIn: [storeId],
      searchText: "",
      searchBy: "",
      recordType: "",
      requestType: "invoice",
      startDate: localeDateStartDate(new Date(startDate)),
      endDate: localeDateEndDate(new Date(endDate)),
      status: ["IN_PROCESS"],
      localeDTO: {},
    };

    fetchAllQrSearchApi(requestData);
  }

  // api calling of get all qrcode in one click
  const handleInvoiceDirectly = (invoice) => {
    if (!invoice?.trim()) {
      setDataProviderSuggestion([]);
      setQrCodes({})
      return;
    }

    // Duplicate tag check
    if (selectedQrCodesChecked.includes(invoice)) {
      setAlreadyPresentData(`Tag ${invoice} already exists.`);
      refocusInput();
      handleAlreadyAddedItem();
      setSearchTermFocus("");
      return;
    }

    const data = {
      brandId,
      storeIdIn: [storeId],
      searchText: invoice,
      searchBy: "invoice",
      recordType: "",
      startDate: localeDateStartDate(new Date(startDate)),
      // stateDate: "2026-06-01T00:00:00.000Z",
      endDate: localeDateEndDate(new Date(endDate)),
      status: ["IN_PROCESS"],
      localeDTO: {}
    };

    fetchQrSearchApi(data, "multi");

  };

  // handle selected all searched data
  const handleSelectAllSearchedData = () => {
    const suggestions = [];
    qrCodes?.forEach((garment, qrCode) => {
      if (qrCode?.toLowerCase().startsWith(searchTerm.toLowerCase())) {
        suggestions.push({ qrCode, garment });
      }
    });

    const newQrCodes = suggestions.filter(
      (item) => !selectedQrCodesChecked.includes(item.qrCode)
    );

    const updatedSelectedQrCodes = [
      ...selectedQrCodes,
      ...newQrCodes.map((item) => ({
        garment: item.garment.garment,
        rfid: item.garment.rfid,
        // createdDate: item.garment.createdDate,
        qrcode: item.qrCode,
      })),
    ];

    setSelectedQrCodes(updatedSelectedQrCodes);
    setDataProvider(updatedSelectedQrCodes);

    const updatedCheckedQrCodes = [
      ...selectedQrCodesChecked,
      ...newQrCodes.map((item) => item.qrCode),
    ];
    setSelectedQrCodesChecked(updatedCheckedQrCodes);
    handleReadyToSendToWarehouseBySelection(updatedSelectedQrCodes)
  };

  // remove tag
  const removeTag = (data) => {
    const updatedTag = selectedQrCodes.filter(
      (item) => item.qrcode !== data.qrcode
    );

    setSelectedQrCodes(updatedTag);
    setDataProvider(updatedTag);

    const updatedSelectedQrCodesChecked =
      selectedQrCodesChecked.filter(
        (code) => ![data.rfid, data.qrcode].includes(code)
      );

    const updatedSelectedQrCodesCheckedRFID =
      selectedQrCodesCheckedRFID.filter(
        (code) => ![data.rfid, data.qrcode].includes(code)
      );

    setSelectedQrCodesChecked(updatedSelectedQrCodesChecked);
    setSelectedQrCodesCheckedRFID(updatedSelectedQrCodesCheckedRFID);
  };

  // handle removed all selected data
  const handleRemoveAllSelectedData = () => {
    // Clear all selected QR codes and checked items
    setSelectedQrCodes([]);
    setSearchTerm("");
    setWarehouseValue("");
    setSelectedQrCodesChecked([]);
    setSelectedQrCodesCheckedRFID([]);

    // Reset the dataProvider to an empty state
    setDataProvider([]);

    // Optionally, reset the suggestions dataProvider
    setDataProviderSuggestion([]);
    setQrCodes({})
  };

  const handleReadyToSendToWarehouseBySelection = (selectedQrCodesList) => {
    // Check if the button has already been pressed
    if (selectedQrCodesList.length > 0) {
      // if (!isSaveButtonPressed) {
        // Set the state to indicate that the button has been pressed
        // setIsSaveButtonPressed(true);
        const data = {
          qrcodeList: selectedQrCodesList.map((qr) => qr.qrcode),
          status: "READY_TO_SEND_WARE_HOUSE",
        };

        getReadyGarmentToSendToWarehouse(storeId, data)
          .then((response) => {
            if (!response.data.error) {
              const Res = response.data;
              // const message = Res.message;
              // const success = Res.status;
              // setIsSaveButtonPressed(false);
              // if (success === true) {
              //   setModalVisible(true);
              //   setModalStatus("success");
              //   setModalText(message);
              //   setTimeout(() => {
              //     navigate("/ReadyToSendToWareHouse");
              //   }, 1500);
              // } else {
              //   setModalVisible(true);
              //   setModalStatus("not Success");
              //   setModalText(message);
              //   setTimeout(() => {
              //     navigate("/StoreWarehouse");
              //   }, 1500);
              // }
            }
          })
          .catch((err) => {
            console.error("Error:", err);
          });
      // }
    } else {
      navigate("/ReadyToSendToWareHouse");
    }
  };

  const handleReadyToSendToWarehouse = () => {
    // Check if the button has already been pressed
    // if (selectedQrCodes.length > 0) {
    //   if (!isSaveButtonPressed) {
    //     // Set the state to indicate that the button has been pressed
    //     setIsSaveButtonPressed(true);
    //     const data = {
    //       qrcodeList: selectedQrCodes.map((qr) => qr.qrcode),
    //       status: "READY_TO_SEND_WARE_HOUSE",
    //     };

    //     getReadyGarmentToSendToWarehouse(storeId, data)
    //       .then((response) => {
    //         if (!response.data.error) {
    //           const Res = response.data;
    //           const message = Res.message;
    //           const success = Res.status;
    //           setIsSaveButtonPressed(false);
    //           if (success === true) {
    //             setModalVisible(true);
    //             setModalStatus("success");
    //             setModalText(message);
    //             setTimeout(() => {
    //               navigate("/ReadyToSendToWareHouse");
    //             }, 1500);
    //           } else {
    //             setModalVisible(true);
    //             setModalStatus("not Success");
    //             setModalText(message);
    //             setTimeout(() => {
    //               navigate("/StoreWarehouse");
    //             }, 1500);
    //           }
    //         }
    //       })
    //       .catch((err) => {
    //         console.error("Error:", err);
    //       });
    //   }
    // } else {
      navigate("/ReadyToSendToWareHouse");
    // }
  };

  const handleSendToWarehouse = () => {
    // Check if the button has already been pressed
    if (!isSendButtonPressed) {
      // Set the state to indicate that the button has been pressed
      setIsSendButtonPressed(true);
      const data = {
        qrcodeList: selectedQrCodes.map((qr) => qr.qrcode),
        status: "READY_TO_SEND_WARE_HOUSE",
      };

      getReadyGarmentToSendToWarehouse(storeId, data)
        .then((response) => {
          if (!response.data.error) {
            const Res = response.data;
            const success = Res.status;
            if (success === true) {
              toGenerateChallan(warehouseValue.code)
                .then((response) => {
                  if (!response.data.error) {
                    const Res = response.data;
                    const data = {
                      qrCodeInfoList: selectedQrCodes.map((item) => ({
                        qrCode: item.qrcode,
                      })),
                      wareHouseStoreChallanDTO: response.data,
                    };

                    postSendToWareHouse(storeId, data)
                      .then((response) => {
                        if (!response.data.error) {
                          const Res = response.data;
                          const message = Res.message;
                          const success = Res.status;
                          if (success === true) {
                            setModalVisible(true);
                            setModalStatus("success");
                            setModalText(message);
                            setIsSendButtonPressed(false);
                            setTimeout(() => {
                              navigate("/ChallanList");
                            }, 1500);
                          } else {
                            setModalVisible(true);
                            setModalStatus("not Success");
                            setModalText(message);
                            setIsSendButtonPressed(false);
                          }
                        }
                      })
                      .catch((err) => {
                        console.error("Error:", err);
                      });
                  }
                })
                .catch((err) => {
                  console.error("Error:", err);
                });
            } else {
              setModalVisible(true);
              setModalStatus("not Success");
              setModalText("");
              // const data = {
              //   status: ["IN_PROCESS"],
              // };
              // fetchData(data);
            }
          }
        })
        .catch((err) => {
          console.error("Error:", err);
        });
    }
  };

  const rowRenderer = () => {
    return dataProvider?.map((item, index) => (
      <div
        key={index}
        className="flex flex-row py-1 mx-2 justify-content-between"
      >
        <p className="flex-1 text-lg font-normal ">{item.qrcode}</p>
        <p className="flex-1 text-lg font-normal ">
          {(item.garment.replace(/_/g, " ") + "").substring(0, 20)}
          {(item.garment + "").length > 20 ? "..." : ""}
        </p>
        <div
          onClick={() => removeTag(item)}
          className="flex-1 text-lg font-normal text-right cursor-pointer"
        >
          <img
            src={
              "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
            }
            style={{ width: "10%" }}
          />
        </div>
      </div>
    ));
  };



  const renderSearchedByInvoiceTagItem = () => {
    if (!allQrcodeData || allQrcodeData?.length === 0) return null;

    // // --- FILTER BY TODAY ---
    // const today = new Date().toISOString().split("T")[0];

    //  const suggestions = [];
    // allQrcodeData?.forEach((garment, qrCode) => {
    //    if (today === garment.createdDate?.split("T")[0]) {
    //      suggestions.push({ qrCode, garment });
    //    }
    //  });

    if (allQrcodeData.length === 0) return <div>No data for today</div>;

    // Group the filtered data
    // const groupedData = groupByInvoice(allQrcodeData);

    return (
      <>
        {allQrcodeData.map((item) => (
          <div key={item.invoiceNo} className="mb-2 border-b pb-2">
            <div className="flex justify-content-between items-center bg-gray-100 px-2 py-2">
              <div className="text-xl font-bold">{item.invoiceNo}</div>

              <div
                onClick={() => handleInvoiceDirectly(item.invoiceNo)}
                className="cursor-pointer text-right"
              >
                <img
                  src="Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Add.png"
                  style={{ width: "40%" }}
                />
              </div>
            </div>

            {/*groupedData[invoiceNo].map((item, index) => {
            const isSelected = selectedQrCodesChecked.includes(item.qrCode);

            return (
              <div
                key={index}
                onClick={() => handleScan({ data: item.qrCode })}
                className="flex flex-row py-1 mx-2 justify-content-between cursor-pointer"
              >
                <p className="flex-1 text-lg">{item.qrCode}</p>

                <p className="flex-1 text-lg">
                  {item.garment.garment.replace(/_/g, " ").substring(0, 20)}
                  {item.garment.garment.length > 20 ? "..." : ""}
                </p>

                <div className="flex-1 text-right">
                  {isSelected ? (
                    <img
                      src="Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
                      style={{ width: "10%" }}
                    />
                  ) : (
                    <img
                      src="Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Add.png"
                      style={{ width: "10%" }}
                    />
                  )}
                </div>
              </div>
            );
          })*/}
          </div>
        ))}
      </>
    );
  };

  const renderSearchedTagItem = () => {
    return dataProviderSuggestion?.map((item, index) => {
      const isSelected = selectedQrCodesChecked.includes(item.qrCode);
      return (
        <div
          key={index}
          onClick={() => handleScan({ data: item.qrCode })}
          className="flex flex-row py-1 mx-2 justify-content-between cursor-pointer"
        >
          <p className="flex-1 text-lg font-normal ">{item.qrCode}</p>
          <p className="flex-1 text-lg font-normal ">
            {(item.garment.garment.replace(/_/g, " ") + "").substring(0, 20)}
            {(item.garment.garment + "").length > 20 ? "..." : ""}
          </p>

          <div className="flex-1 text-lg font-normal text-right">
            <div>
              {isSelected ? (
                <img
                  src={
                    "Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
                  }
                  style={{ width: "10%" }}
                />
              ) : (
                <img
                  src={"Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Add.png"}
                  style={{ width: "10%" }}
                />
              )}
            </div>
          </div>
        </div>
      );
    });
  };

  const handleBackButton = () => {
    navigate("/StoreWarehouse");
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div onClick={() => refocusInput()}>
                <p> </p>
              </div>

              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => handleBackButton()}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className=" text-2xl text-white font-bold capitalize">
                Send To Warehouse
              </p>
            </div>

            <div
              className="flex justify-content-center align-items-center mr-3 cursor-pointer"
              style={{
                backgroundColor: "green",
                borderRadius: 5,
              }}
              title="Booked Garments In Store"
            >
              <p className="text-lg text-white font-normal text-center">
                {inProcessCount[0]?.count}
              </p>
            </div>

            <div className=" mx-4 cursor-pointer" title="Start Date" >
              <Calendar
                id="buttondisplay"
                value={startDate}
                onChange={(e) => handleStartDateChange(e.value)}
                showIcon
                minDate={minimumDate}
                maxDate={new Date()}
                className="  bg-white-alpha-20 border-round-lg text-lg text-primary-50"
                dateFormat="dd/mm/yy"
                style={{ height: 30, width: 180 }}
              />
            </div>

            <div
              onClick={() => {
                handleAllTodayQrCode();
                setSearchByInvoiceMethod(true);
                setSearchMethod(false);
                setQrMethod(false);
                setRfidMethod(false);
                refocusInput();
                setSearchTerm("");
                setSearchTermFocus("");
                setAlreadyPresentData("");
              }}
              className="cursor-pointer" title="Select By Invoice No."
            >
              <div
                className="flex justify-content-center align-items-center cursor-pointer"
                style={{
                  height: 32,
                  width: 32,
                  marginRight: 30,
                }}
              >
                <img
                  src={"Img/searchInvoice.png"}
                  style={{ height: 28, width: 28 }}
                />
              </div>
            </div>
            <div
              onClick={() => {
                setSearchMethod(true);
                setQrMethod(false);
                setRfidMethod(false);
                setSearchByInvoiceMethod(false);
                refocusInput();
                setSearchTerm("");
                setSearchTermFocus("");
                setAlreadyPresentData("");
              }}
              className="cursor-pointer" title="Search By Invoice No."
            >
              <div
                className="flex justify-content-center align-items-center cursor-pointer"
                style={{
                  height: 32,
                  width: 32,

                  marginRight: 30,
                }}
              >
                <i
                  className="pi pi-search"
                  style={{ fontSize: "27px", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div
              onClick={() => {
                setQrMethod(true);
                setSearchMethod(false);
                setSearchByInvoiceMethod(false);
                setRfidMethod(false);
                refocusInput();
                setSearchTerm("");
                setSearchTermFocus("");
                setAlreadyPresentData("");
              }}
              className="cursor-pointer" title="Scan By Tag Gun"
            >
              <div
                className="flex justify-content-center align-items-center border-1 cursor-pointer"
                style={{
                  height: 32,
                  width: 32,
                  backgroundColor: "#fff",

                  marginRight: 30,
                  borderColor: "#fff",
                }}
              >
                <img
                  src={"images/qr-code.png"}
                  style={{ height: 28, width: 28 }}
                />
              </div>
            </div>
            {enabledRfIdModal && (
              <div
                onClick={() => {
                  setRfidMethod(true);
                  setQrMethod(false);
                  setSearchMethod(false);
                  setSearchByInvoiceMethod(false);
                  refocusInput();
                  setSearchTerm("");
                  setSearchTermFocus("");
                  setAlreadyPresentData("");
                }}
                className="cursor-pointer" title="Scan By RFID"
              >
                <div
                  className="flex justify-content-center align-items-center cursor-pointer"
                  style={{
                    height: 32,
                    width: 32,
                    marginRight: 30,
                  }}
                >
                  <img
                    src={"images/rfid-tags.png"}
                    style={{ height: 38, width: 38 }}
                  />
                </div>
              </div>
            )}
            <div
              className="ml-3 flex justify-content-center align-items-center mr-4 cursor-pointer" title="Ready To Sent To Warehouse"
              style={{
                pointerEvents:
                  isSendButtonPressed || isSaveButtonPressed ? "none" : "auto",
              }}
            >
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center cursor-pointer">
                <i
                  className="pi pi-shopping-bag"
                  style={{ fontSize: "27px", color: "#fff" }}
                  onClick={() => handleReadyToSendToWarehouse()}
                ></i>
                <div
                  style={{
                    right: 0,
                    position: "absolute",
                    top: 2,
                    backgroundColor: "red",
                    borderRadius: 20,
                    minWidth: 30,
                    height: 30,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <p
                    className=" text-md text-white font-semibold text-center"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {selectedQrCodes.length > 0
                      ? "+" + selectedQrCodes.length
                      : qrCodes2[0]?.count}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="flex-1 flex flex-column justify-content-center align-items-center">
          <ProgressSpinner />

          <p
            style={{
              color: "#000",
              fontSize: 20,
              fontWeight: "700",
              alignSelf: "center",
            }}
          >
            Garment List is Loading...
          </p>
        </div>
      ) : (
        <div className="flex flex-1 ">
          <div className="flex-1">
            {!loading && (
              <div
                className="flex-1"
                style={{
                  pointerEvents:
                    isSendButtonPressed || isSaveButtonPressed
                      ? "none"
                      : "auto",
                }}
              >
                {searchMethod && (
                  <div className="mt-3 mb-1 mx-4 flex flex-row justify-content-between">
                    <div className=" flex flex-1">
                      <IconField iconPosition="left" className="flex flex-1">
                        <InputIcon className="pi pi-search text-xl"></InputIcon>
                        <InputText
                          placeholder="Search Invoice No."
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          className="text-xl flex flex-1 py-1 px-5"
                          style={{ borderRadius: 30 }}
                        />
                      </IconField>
                    </div>
                    {dataProviderSuggestion?.length > 0 && (
                      <div
                        className="flex justify-content-center align-items-center cursor-pointer"
                        onClick={handleSelectAllSearchedData}
                      >
                        <img
                          src={
                            "Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Add.png"
                          }
                          style={{ width: "50%" }}
                        />
                      </div>
                    )}
                  </div>
                )}

                {enabledRfIdModal && rfidMethod && (
                  <div className="mt-3 mb-1 mx-4 flex flex-row justify-content-between">
                    <div className=" flex flex-1">
                      <IconField iconPosition="left" className="flex flex-1">
                        <InputIcon className="pi pi-search text-xl"></InputIcon>
                        <InputText
                          className="text-xl flex flex-1 py-1 px-5"
                          style={{ borderRadius: 30 }}
                          ref={inputRef}
                          value={searchTermFocus}
                          onChange={(e) => setSearchTermFocus(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              handleScanRFID({ data: searchTermFocus });
                            }
                          }}
                          placeholder="Scan RFID Tag"
                          showSoftInputOnFocus={false}
                          autoFocus={true}
                        />
                      </IconField>
                    </div>
                    {searchTermFocus && (
                      <div
                        className="flex justify-content-end align-items-center cursor-pointer"
                        onClick={() => handleClearSearch()}
                      >
                        <p
                          className="text-3xl font-bold ml-4"
                          style={{ color: "red" }}
                        >
                          X
                        </p>
                      </div>
                    )}
                  </div>
                )}
                {qrMethod && (
                  <div className="mt-3 mb-1 mx-4 flex flex-row justify-content-between">
                    <div className=" flex flex-1">
                      <IconField iconPosition="left" className="flex flex-1">
                        <InputIcon className="pi pi-search text-xl"></InputIcon>
                        <InputText
                          className="text-xl flex flex-1 py-1 px-5"
                          style={{ borderRadius: 30 }}
                          ref={inputRef}
                          value={searchTermFocus}
                          onChange={(e) => setSearchTermFocus(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              handleScanQrMethod({ data: searchTermFocus });
                            }
                          }}
                          placeholder="Scan QR Code"
                          showSoftInputOnFocus={false}
                          autoFocus={true}
                        />
                      </IconField>
                    </div>
                    {searchTermFocus && (
                      <div
                        className="flex justify-content-end align-items-center cursor-pointer"
                        onClick={() => handleClearSearch()}
                      >
                        <p
                          className="text-3xl font-bold ml-4"
                          style={{ color: "red" }}
                        >
                          X
                        </p>
                      </div>
                    )}
                  </div>
                )}

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <p
                    className="flex-1 text-2xl font-medium text-center"
                    style={{ color: "green" }}
                  >
                    {alreadyPresentData}
                  </p>
                </div>
                {qrMethod || rfidMethod ? (
                  <div className="my-3">
                    <p className=" text-3xl  font-bold text-center">
                      Please Scan Tag
                    </p>
                  </div>
                ) : dataProviderSuggestion?.length !== 0 ? (
                  <div
                    style={{
                      pointerEvents:
                        isSendButtonPressed || isSaveButtonPressed
                          ? "none"
                          : "auto",
                    }}
                  >
                    <div className="flex flex-row py-1 mx-2 justify-content-between">
                      <p className="flex-1 text-2xl font-medium ">Tag</p>
                      <p className="flex-1 text-2xl font-medium">Garment</p>

                      <p className="flex-1 text-2xl font-medium text-right">
                        Add
                      </p>
                    </div>
                    <div style={{ overflowY: "auto", height: "75vh" }}>
                      {renderSearchedTagItem()}
                    </div>
                  </div>
                ) : searchByInvoiceMethod ? (
                  <div className="my-3">
                    <p className=" text-3xl  font-bold text-center">
                      Please Add Tag By Invoice
                    </p>
                  </div>
                ) : (
                  <div className="my-3">
                    <p className=" text-3xl  font-bold text-center">
                      Please Search Tag
                    </p>
                  </div>
                )}

                {allQrcodeData?.length !== 0 && searchByInvoiceMethod && (
                  <div
                    style={{
                      pointerEvents:
                        isSendButtonPressed || isSaveButtonPressed
                          ? "none"
                          : "auto",
                    }}
                  >
                    <div className="flex flex-row py-1 mx-2 justify-content-between">
                      <p className="flex-1 text-2xl font-medium ">Invoice No.</p>
                      <p className="flex-1 text-2xl font-medium text-right">
                        Add
                      </p>
                    </div>
                    <div style={{ overflowY: "auto", height: "75vh" }}>
                      {renderSearchedByInvoiceTagItem()}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
          <div
            className=" flex-1 surface-0"
            style={{
              "--surface-0": "#f2f2f2",
            }}
          >
            <div>
              <div className="flex-1">
                <div className="flex-1">
                  <div className="mt-3 mb-1 mx-4 flex flex-row justify-content-between">
                    <p className="w-full text-3xl  font-bold text-start">
                      Selected Garments Tag List
                    </p>

                    {selectedQrCodes.length > 0 && (
                      <div
                        className="flex justify-content-end align-items-center cursor-pointer"
                        onClick={handleRemoveAllSelectedData}
                      >
                        <img
                          src={"images/Cross.jpeg"}
                          style={{ width: "10%" }}
                        />
                      </div>
                    )}
                  </div>
                </div>

                {selectedQrCodes.length === 0 ? (
                  <div>
                    <p className=" text-3xl  font-bold text-center">
                      Please Select Tag
                    </p>
                  </div>
                ) : (
                  <div
                    style={{
                      pointerEvents:
                        isSendButtonPressed || isSaveButtonPressed
                          ? "none"
                          : "auto",
                    }}
                  >
                    <div className="flex flex-row py-1 mx-2 justify-content-between">
                      <p className="flex-1 text-2xl font-medium ">Tag</p>
                      <p className="flex-1 text-2xl font-medium">Garment</p>

                      <p className="flex-1 text-2xl font-medium text-right">
                        Action
                      </p>
                    </div>
                    <div>
                      <div style={{ overflowY: "auto", height: "55vh" }}>
                        {rowRenderer()}
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <SuccessModal
                setModalVisible={setModalVisible}
                modalVisible={modalVisible}
                status={modalStatus}
                text={modalText}
              />
            </div>
            {selectedQrCodes.length > 0 && (
              <div className="my-1 mx-2">
                <div className="mx-2 mt-2">
                  <Dropdown
                    // value={
                    //   warehouseValue ? warehouseValue : warehouseList[0].name
                    // }
                    value={warehouseValue}
                    onChange={(e) => handleWarehouseChange(e.value)}
                    options={warehouseList}
                    placeholder="Select Warehouse"
                    disabled={isSendButtonPressed}
                    optionLabel="name"
                    className="w-full  bg-white-alpha-20 border-round-xl text-2xl text-primary-50"
                  />
                </div>

                <div className="flex-1 mx-2 mb-1 mt-3 sticky z-2 bottom-0">
                  <div
                    className=" flex justify-content-center"
                    style={{
                      pointerEvents:
                        isSendButtonPressed || isSaveButtonPressed
                          ? "none"
                          : "auto",
                    }}
                  >
                    <Button
                      onClick={handleSendToWarehouse}
                      disabled={
                        warehouseValue === undefined || warehouseValue === ""
                          ? true
                          : isSendButtonPressed
                      }
                      className="flex justify-content-center text-2xl w-full border-round-xl border-none cursor-pointer"
                    >
                      <p className="text-xl font-bold text-white text-center">
                        {isSendButtonPressed
                          ? "Generating..."
                          : "Generate Challan"}
                      </p>

                      <div className="flex justify-content-center ml-5 relative">
                        <i
                          className="pi pi-shopping-cart"
                          style={{ fontSize: "27px", color: "#fff" }}
                        ></i>
                        <div
                          style={{
                            left: 28,
                            position: "absolute",
                            top: -10,
                            backgroundColor: "red",
                            borderRadius: 20,
                            minWidth: 36,
                            height: 36,
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <p className=" text-md  font-normal text-center">
                            {selectedQrCodes.length}
                          </p>
                        </div>
                      </div>
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SendToWarehouse;
